import { z } from "zod";

import { COMMISSION_DEBT_ERROR_CODE, IBAN_PATTERN, normalizeIban } from "@/lib/billing/constants";

export const commissionDebtErrorSchema = z.object({
  error: z.literal(COMMISSION_DEBT_ERROR_CODE),
  message_fa: z.string().optional(),
  outstanding_debt: z.coerce.number().optional(),
  debt_limit: z.coerce.number().optional(),
  pay_url: z.string().optional(),
});

export type CommissionDebtError = z.infer<typeof commissionDebtErrorSchema>;

export function parseCommissionDebtError(data: unknown): CommissionDebtError | null {
  const result = commissionDebtErrorSchema.safeParse(data);
  return result.success ? result.data : null;
}

// Optional IBAN; spaces and lowercase are accepted (the backend normalizes them).
export const ibanSchema = z
  .string()
  .optional()
  .refine((value) => !value || IBAN_PATTERN.test(normalizeIban(value)), {
    error: "شماره شبا باید با IR شروع شود و ۲۴ رقم داشته باشد",
  });
